import { drawRoundedPolygon, sizeOptionsOrDefault } from './utils';
import { MultiPathShape } from './MultiPathShape';
const defaultOptions = {
    sideLineOffsetRatio: 0.1
};
/**
 * Represents a Predefined Process shape, a flowchart element used to indicate
 * a process that is defined elsewhere. Extends MultiPathShape with a rectangle
 * containing vertical side lines.
 */
export class PredefinedProcess extends MultiPathShape {
    /**
     * Creates a new PredefinedProcess instance.
     * @param options - Configuration options for the predefined process shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /**
     * @hidden
     * Draws the predefined process shape path as a rectangle with vertical lines.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const sideLineOffsetRatio = this.options.sideLineOffsetRatio;
        const sideLineOffset = width * sideLineOffsetRatio;
        const leftLineX = sideLineOffset;
        const rightLineX = width - sideLineOffset;
        const points = [
            { x: 0, y: 0 },
            { x: width, y: 0 },
            { x: width, y: height },
            { x: 0, y: height }
        ];
        drawRoundedPolygon(drawingElement, points, this.options.cornerRadius);
        drawingElement
            .moveTo(leftLineX, 0)
            .lineTo(leftLineX, height)
            .moveTo(rightLineX, 0)
            .lineTo(rightLineX, height);
    }
}
